import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  getJobSeekerStats,
  getJobSeekers,
  updateJobSeekerVerification,
  updateJobSeekerStatus,
  updateJobSeekerPlan,
  bulkJobSeekerAction,
  exportJobSeekers
} from "../../adminAPI/adminJobSeekersApi";

import { formatRelativeDate, formatDateDDMMYYYY } from "../../utils/dateUtils";
import Pagination from "../../components/common/Pagination";


const JobsManagement = () => {
const token = localStorage.getItem("otoken");
const [stats, setStats] = useState({});
const [seekers, setSeekers] = useState([]);
const navigate = useNavigate();
const [selectedIds, setSelectedIds] = useState([]);
const [selectAll, setSelectAll] = useState(false);
const selectedCount = selectedIds.length;
// Pagination
const [page, setPage] = useState(1);
const [total, setTotal] = useState(0);
const PAGE_SIZE = Number(process.env.REACT_APP_TABLE_DEF_LENGTH);

const [filters, setFilters] = useState({
  search: "",
  kyc_status: "",
  plan: "",
  status: "",
  date_range: "",
});


const loadStats = async () => {
  const data = await getJobSeekerStats(token);
  setStats(data);
};

const loadSeekers = async () => {
  const data = await getJobSeekers(
    { ...filters, page, limit: PAGE_SIZE },
    token
  );

  setSeekers(data.rows || []);
  setTotal(Number(data.total) || 0);
};


const handleBulk = async (action) => {
  if (!selectedIds.length) return;

  await bulkJobSeekerAction(
    { action, ids: selectedIds },
    token
  );

  setSelectedIds([]);
  loadSeekers();
};

const handleBulkAction = async (action) => {
  if (!selectedIds.length) return alert("No candidates selected");

  await bulkJobSeekerAction(
    { action, ids: selectedIds },
    token
  );

  setSelectedIds([]);
  setSelectAll(false);
  loadSeekers();
};


const toggleSelect = (id) => {
  setSelectedIds(prev =>
    prev.includes(id)
      ? prev.filter(x => x !== id)
      : [...prev, id]
  );
};

const toggleSelectAll = (list) => {
  if (selectAll) {
    setSelectedIds([]);
  } else {
    setSelectedIds(list.map(item => item.seeker_id));
  }
  setSelectAll(!selectAll);
};


const verifySeeker = async (id) => {
  await updateJobSeekerVerification(id, "Verified", token);
  loadSeekers();
};

const suspendSeeker = async (id) => {
  await updateJobSeekerVerification(id, "Suspended", token);
  loadSeekers();
};

const handleExport = async () => {
  const data = await exportJobSeekers(token);
  console.log("Export data:", data);
};

const handleFilterChange = (e) => {
  setFilters(prev => ({
    ...prev,
    [e.target.name]: e.target.value
  }));
  setPage(1);
};


useEffect(() => {
  loadStats();
  loadSeekers();
}, [page, filters]);



  return (
    <>
            {/* <!-- Page header --> */}
        <div className="page-header mb-4 d-flex flex-wrap justify-content-between align-items-center" style={{ marginLeft: "30px", marginRight: "30px" }}>
          <div className="mb-3 mb-md-0">
            <h1 className="h4 mb-1">Job Seekers Management</h1>
            <p className="text-muted mb-0">
              Manage candidate profiles, applications, verification status, and profile completeness.
            </p>
          </div>
          <div className="d-flex flex-wrap gap-2">
            <button className="btn btn-sm btn-outline-secondary"
            onClick={handleExport}>
              <i className="bi-download me-1"></i> Export
            </button>
            <button className="btn btn-sm btn-primary" data-bs-toggle="modal" data-bs-target="#addSeekerModal">
              <i className="bi-plus-lg me-1"></i> Add Candidate
            </button>
          </div>
        </div>

        {/* <!-- Stats cards --> */}
        <div className="row g-3 mb-4" style={{ marginLeft: "30px", marginRight: "30px" }}>
          <div className="col-md-3">
            <div className="card stats-card shadow-sm" >
              <div className="card-body d-flex justify-content-between align-items-center">
                <div>
                  <div className="small text-muted text-uppercase">Total Candidates</div>
                  <div className="h5 mb-0">{stats.total || 0}</div>
                  <small className="text-success">
                    <i className="bi-arrow-up-right"></i> 15% this month
                  </small>
                </div>
                <div className="stats-icon bg-primary text-white">
                  <i className="bi-people"></i>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card stats-card shadow-sm">
              <div className="card-body d-flex justify-content-between align-items-center">
                <div>
                  <div className="small text-muted text-uppercase">Verified</div>
                  <div className="h5 mb-0">{stats.verified || 0}</div>
                  {/* <small className="text-success">
                    <i className="bi-check-circle"></i> 71% verified
                  </small> */}
                </div>
                <div className="stats-icon bg-success text-white">
                  <i className="bi-shield-check"></i>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card stats-card shadow-sm">
              <div className="card-body d-flex justify-content-between align-items-center">
                <div>
                  <div className="small text-muted text-uppercase">Active</div>
                  <div className="h5 mb-0">{stats.active || 0}</div>
                  <small className="text-primary">
                    <i className="bi-clock"></i> Applied recently
                  </small>
                </div>
                <div className="stats-icon bg-info text-white">
                  <i className="bi-activity"></i>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card stats-card shadow-sm">
              <div className="card-body d-flex justify-content-between align-items-center">
                <div>
                  <div className="small text-muted text-uppercase">Premium</div>
                  <div className="h5 mb-0">{stats.premium || 0}</div>
                  {/* <small className="text-warning">
                    <i className="bi-star"></i> ₹3.2Cr revenue
                  </small> */}
                </div>
                <div className="stats-icon bg-warning text-white">
                  <i className="bi-star-fill"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <!-- Filters --> */}
        <div className="card shadow-sm mb-4" style={{ marginLeft: "30px", marginRight: "30px" }}>
          <div className="card-body">
            <form className="row g-3 align-items-end filters-row">
              <div className="col-md-3">
                <label className="form-label small text-muted mb-1">Search</label>
                <div className="input-group input-group-sm">
                  <span className="input-group-text bg-white border-end-0">
                    <i className="bi-search"></i>
                  </span>
                  <input
                    type="text"
                    className="form-control border-start-0"
                    placeholder="Name, email, skills, phone..."
                    name="search"
                    onChange={handleFilterChange}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <label className="form-label small text-muted mb-1">Verification</label>
                <select className="form-select form-select-sm" name="verification" onChange={handleFilterChange}>
                  <option value="">All</option>
                  <option value="verified">Verified</option>
                  <option value="pending">Pending</option>
                  <option value="rejected">Rejected</option>
                </select>
              </div>
              <div className="col-md-2">
                <label className="form-label small text-muted mb-1">Experience</label>
                <select className="form-select form-select-sm" name="experience">
                  <option value="">All</option>
                  <option value="fresher">Fresher</option>
                  <option value="1-3">1-3 years</option>
                  <option value="3-5">3-5 years</option>
                  <option value="5+">5+ years</option>
                </select>
              </div>
              <div className="col-md-2">
                <label className="form-label small text-muted mb-1">Status</label>
                <select className="form-select form-select-sm" name="status">
                  <option value="">All</option>
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                  <option value="suspended">Suspended</option>
                </select>
              </div>
              <div className="col-md-2">
                <label className="form-label small text-muted mb-1">Location</label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="City/State"
                  name="location"
                />
              </div>
              {/* <div className="col-md-1">
                <button type="submit" className="btn btn-sm btn-primary w-100">
                  Apply
                </button>
              </div> */}
            </form>

            {/* <!-- Active filters chips --> */}
            {/* <div className="mt-3 d-flex flex-wrap align-items-center gap-2">
              <span className="small text-muted me-1">Active filters:</span>
              <span className="badge bg-light text-secondary border filter-chip">
                Exp: 3-5 yrs <i className="bi-x ms-1"></i>
              </span>
              <span className="badge bg-light text-secondary border filter-chip">
                Verified <i className="bi-x ms-1"></i>
              </span>
              <button className="btn btn-link btn-sm p-0 small text-decoration-none">
                Clear all
              </button>
            </div> */}
          </div>
        </div>

        {/* <!-- Bulk actions & table --> */}
        <div className="card shadow-sm" style={{ marginLeft: "30px", marginRight: "30px" }}>
          <div className="card-body border-bottom pb-3 d-flex flex-wrap justify-content-between align-items-center">
            <div className="d-flex align-items-center gap-2 mb-2 mb-md-0">
              <div className="form-check mb-0">
                
                <label className="form-check-label small" for="selectAllSeekers">
                  Select all
                </label>
              </div>
              <div className="dropdown">
                <button
                  className="btn btn-sm btn-outline-secondary dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                >
                  Bulk actions
                </button>
                <ul className="dropdown-menu">
                  <li><button className="dropdown-item" onClick={() => handleBulkAction("verify")}>Verify selected</button></li>
                  <li><button className="dropdown-item" onClick={() => handleBulkAction("suspend")}>Suspend accounts</button></li>
                  <li><button className="dropdown-item">Send notifications</button></li>
                  <li><hr className="dropdown-divider" /></li>
                  <li><button className="dropdown-item text-danger">Delete selected</button></li>
                </ul>
              </div>
              <span className="small text-muted">{selectedCount} selected</span>
            </div>

            <div className="d-flex align-items-center gap-2">
              <span className="small text-muted">Sort by:</span>
              <select className="form-select form-select-sm w-auto">
                <option>Newest</option>
                <option>Most active</option>
                <option>Applications</option>
                <option>Profile complete</option>
              </select>
            </div>
          </div>

          <div className="table-responsive">
            <table className="table align-middle mb-0">
              <thead>
                <tr>
                  <th style={{width: "50px"}}>
                      <input 
                        style={{marginTop: "-5px", marginLeft: "8px"}} 
                        className="form-check-input" 
                        type="checkbox" 
                        id="selectAllSeekers"
                        checked={selectAll}
                        onChange={() => toggleSelectAll(seekers)} 
                      />
                  </th>
                  <th>Candidate</th>
                  {/* <th>Experience</th>
                  <th>Skills</th>
                  <th>Applications</th> */}
                  <th>Profile</th>
                  <th>Status</th>
                  {/* <th>Last Active</th> */}
                  <th className="text-end">Actions</th>
                </tr>
              </thead>
              <tbody>
              {seekers.map(seeker => (
                <tr key={seeker.seeker_id}>
                  <td>
                    <input
                      style={{marginTop: "-5px", marginLeft: "8px"}}
                      type="checkbox"
                      className="form-check-input"
                      checked={selectedIds.includes(seeker.seeker_id)}
                      onChange={() => toggleSelect(seeker.seeker_id)}
                    />
                  </td>

                  <td>
                    <div className="fw-semibold">{seeker.full_name}</div>
                    <small className="text-muted">
                      {seeker.seeker_code} | {seeker.email}
                    </small>
                  </td>

                  {/* <td>
                    <div>{seeker.experience || "—"}</div>
                    <small className="text-muted">{seeker.current_role}</small>
                  </td>

                  <td>
                    {seeker.skills?.split(",").map(skill => (
                      <span key={skill} className="badge bg-secondary-subtle text-secondary border me-1">
                        {skill}
                      </span>
                    ))}
                  </td>

                  <td>
                    <div>{seeker.total_applications || 0}</div>
                  </td> */}

                  <td>
                    <div className="progress mb-1">
                      <div
                        className="progress-bar"
                        style={{ width: `${seeker.profile_completion || 0}%` }}
                      />
                    </div>
                    <small>{seeker.profile_completion || 0}%</small>
                  </td>

                  <td>
                    <span
                      className={`badge border badge-status ${
                        seeker.verification_status === "Verified"
                          ? "bg-success-subtle text-success"
                          : seeker.verification_status === "Suspended"
                          ? "bg-danger-subtle text-danger"
                          : "bg-secondary-subtle text-secondary"
                      }`}
                    >
                      {seeker.verification_status}
                    </span>

                  </td>

                  {/* <td>zzzz</td> */}

                  <td className="text-end">
                     <button
                                  className="btn btn-sm btn-outline-info me-1 mr-2"
                                  title="View Jobs"
                                   onClick={() =>
                                    navigate(
                                      `/employer/view-applicant/jobs/${seeker.seeker_id}`
                                    )
                                  }                                
                                >
                                  <i className="fa fa-eye"></i>
                                </button>
                    <button
                      className="btn btn-sm btn-outline-success me-1"
                      onClick={() => verifySeeker(seeker.seeker_id)}
                     
                    >
                       <i class="fa fa-solid fa-check"  tooltip="Verify" ></i>
                    </button>

                    <button
                      className="btn btn-sm btn-outline-danger"
                      onClick={() => suspendSeeker(seeker.seeker_id)}
                    >
                      <i class="fa fa-solid fa-pause"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>

            </table>
          </div>

          {/* <!-- Pagination --> */}
         <Pagination
            page={page}
            limit={PAGE_SIZE}
            total={total}
            label="Candidates"
            onPageChange={setPage}
          />
        </div>


            </>
        
  );
};

export default JobsManagement;
